export class CopilotRecommendationServiceError extends Error {
  public api: string;

  public requestId: string | null;

  constructor(message: string, api: string, jqXHR: any) {
    super(message);
    this.name = 'CopilotRecommendationServiceError';
    this.api = api;
    this.requestId = jqXHR?.getResponseHeader?.('x-ms-requestid');
  }
}
